module.exports = __webpack_public_path__ + "assets/128f4d78b9e513c0930f709869e5f7d0.png";